// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatRouteResponse" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { CrisisBannerGenShape } from "./crisis-banner.gen";
import { ClarifierPickerPromptGenShape } from "./clarifier-picker-prompt.gen";
import { TenurePickerPromptGenShape } from "./tenure-picker-prompt.gen";
import { RouteMatchGenShape } from "./route-match.gen";
import { ChatRoutingOutcome } from "./chat-routing-outcome.enum.gen";
import { RouteContactGenShape } from "./route-contact.gen";
import { ChatRouteStateGenShape } from "./chat-route-state.gen";

export const ChatRouteResponseGenShape = z.strictObject({
  crisis: z.array(CrisisBannerGenShape),
  halted: z.boolean(),
  clarifyingQuestion: z.string().optional(),
  clarifierPicker: ClarifierPickerPromptGenShape.optional(),
  tenurePicker: TenurePickerPromptGenShape.optional(),
  matches: z.array(RouteMatchGenShape),
  coverageGaps: z.array(z.string()),
  outcome: z.enum(ChatRoutingOutcome),
  contact: RouteContactGenShape.optional(),
  state: ChatRouteStateGenShape,
  redactedCategories: z.array(z.string()),
  correlationId: z.string().optional(),
});
